import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";

const UmbrellaContainers = () => {
  const [containers, setContainers] = useState([]);
  const [filteredContainers, setFilteredContainers] = useState([])
  
  const [activeTab, setActiveTab] = useState("SHIPPED");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleCountryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCountry(selectedValue);

    const countryMap = {
      "CHINA-INDIA": { from: "CHINA", to: "INDIA" },
      "CHINA-CANADA": { from: "CHINA", to: "CANADA" },
      "INDIA-CANADA": { from: "INDIA", to: "CANADA" },
      "INDIA-USA": { from: "INDIA", to: "USA" },
    };

    if (selectedValue === "") {
      setFrom("");
      setTo("");
    } else if (countryMap[selectedValue]) {
      setFrom(countryMap[selectedValue].from);
      setTo(countryMap[selectedValue].to);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const getContainers = async () => {
    setLoading(true);
    try {
      let body = { order_status: activeTab, from, to };
      let response = await axios.post(
        `${BaseUrl}/get-umbrella-containers-master`,
        body
      );
      if (response.status === 200) {
        setContainers(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    getContainers();
  }, [activeTab, from, to]);
  useEffect(()=>{
    if(searchTerm.trim() === ""){

      setFilteredContainers(containers);
    }else{

      
       const filtered = containers.filter((container) =>
         container.identifier_id
           ?.toLowerCase()
           .includes(searchTerm.toLowerCase())
       );
       setFilteredContainers(filtered);
    }
  },[searchTerm,containers])
  const paginatedContainers = filteredContainers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const tabOptions = [
    { value: "", label: "Select Country" },
    { value: "CHINA-INDIA", label: "CHINA - INDIA" },
    { value: "CHINA-CANADA", label: "CHINA - CANADA" },
    { value: "INDIA-CANADA", label: "INDIA - CANADA" },
    { value: "INDIA-USA", label: "INDIA - USA" },
  ];

  return (
    <MasterLayout>
      <Breadcrumb title="umbrella management" />
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header py-16 pb-0 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex align-items-center flex-wrap justify-content-between">
            {/* <h6 className="text-lg mb-0">Umbrella Management</h6> */}
              <div className="search-container position-relative">
                            <input
                              type="text"
                              className="form-control ps-4 pe-5"
                              placeholder="Search by container name"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              style={{ minWidth: "300px" }}
                            />
                            <Icon icon="solar:magnifer-linear" className="position-absolute" style={{ right: "15px", top: "50%", transform: "translateY(-50%)", color: "#6c757d" }} />
                          </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div className="position-relative" style={{ minWidth: "180px" }}>
                <Icon
                  icon="solar:alt-arrow-down-outline"
                  className="position-absolute"
                  style={{
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6c757d",
                    zIndex: 1,
                  }}
                />
                <select
                  className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                  style={{
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  {tabOptions.map((tab) => (
                    <option key={tab.value} value={tab.value}>
                      {tab.label}
                    </option>
                  ))}
                </select>
              </div>
              <ul
                className="nav bordered-tab d-inline-flex nav-pills mb-0"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link px-16 py-10 ${activeTab === "SHIPPED" ? "active" : ""
                      }`}
                    type="button"
                    onClick={() => setActiveTab("SHIPPED")}
                  >
                    Shipped
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link px-16 py-10 ${activeTab === "REACHED_TO_LOCAL_PARTNER" ? "active" : ""
                      }`}
                    type="button"
                    onClick={() => setActiveTab("REACHED_TO_LOCAL_PARTNER")}
                  >
                    Reached To Local Partner
                  </button>
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="card-body">
            <div className="table-responsive">
              <table className="table basic-border-table mb-0">
                <thead>
                  <tr>
                    <th>Created On</th>
                    <th>Container Name</th>
                    <th>Order Count</th>
                    <th>Container Status</th>
                    <th>Shipment Type</th>
                    <th>Expected Delivery</th>
                    {!(from && to) && <th>Route (From → To)</th>}
                  </tr>
                </thead>
                <tbody>
                  {paginatedContainers?.map((items, index) => (
                    <tr key={index}>
                      <td>{formatDate(items?.createdAt)}</td>
                      <td>{items?.identifier_id}</td>
                      <td>{items?.shipment_orders.length}</td>
                      <td>{items.order_status}</td>
                      <td>{items.shipment_type}</td>
                      <td>{formatDate(items?.expected_date)}</td>
                      {!(from && to) && (
                        <td>{items.from + " -To- " + items.to}</td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {containers.length > itemsPerPage && (
              <div className="mt-4 d-flex justify-content-between align-items-center">
                <span>
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {Math.min(currentPage * itemsPerPage, containers.length)} of{" "}
                  {containers.length} containers
                </span>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      setCurrentPage((prev) =>
                        prev < Math.ceil(containers.length / itemsPerPage)
                          ? prev + 1
                          : prev
                      )
                    }
                    disabled={
                      currentPage ===
                      Math.ceil(containers.length / itemsPerPage)
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div> */}
          <div className="card-body">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "calc(100vh - 300px)",
                  width: "100%",
                  background: "transparent",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: "#243E85",
                    width: "3rem",
                    height: "3rem",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : paginatedContainers.length === 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "200px",
                  width: "100%",
                  fontSize: "1.2rem",
                  color: "#243E85",
                  fontWeight: 500,
                }}
              >
                No containers found.
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table basic-border-table mb-0">
                    <thead>
                      <tr>
                        <th>Created On</th>
                        <th>Container Name</th>
                        <th>Order Count</th>
                        {/* <th>Status</th> */}
                        <th>Type</th>
                        <th>Expected Delivery</th>
                        {!(from && to) && <th>Route (From → To)</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedContainers?.map((items, index) => (
                        <tr key={index}>
                          <td>{formatDate(items?.createdAt)}</td>
                          <td>{items?.identifier_id}</td>
                          <td>{items?.shipment_orders.length}</td>
                          {/* <td>{items.order_status}</td> */}
                          <td>{items.shipment_type}</td>
                          <td>{formatDate(items?.expected_date)}</td>
                          {!(from && to) && (
                            <td>{items.from + " -To- " + items.to}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {containers.length > itemsPerPage && (
                  <div className="mt-4 d-flex justify-content-between align-items-center">
                    <span>
                      Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                      {Math.min(currentPage * itemsPerPage, containers.length)} of{" "}
                      {containers.length} containers
                    </span>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            prev < Math.ceil(containers.length / itemsPerPage)
                              ? prev + 1
                              : prev
                          )
                        }
                        disabled={currentPage === Math.ceil(containers.length / itemsPerPage)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default UmbrellaContainers;